<template>
  <specialist-picker
      ref="specialistPicker"
      :filter="filterSpecialists"
      :show-icon="false"
      :value="derivation && derivation.specialist || null"
      :label="label"
      v-on:change="onSpecialistSelect"
      :serviceProviderId="currentProvider && currentProvider.id || null" />
</template>

<script>
import SpecialistPicker from "@/components/providers/SpecialistPicker";
import {debounce} from "@/utils/Common";
import {ApiUtils} from "@/utils/ApiUtils";

export default {
  name: "SpecialistDerivationUpdater",
  components: {SpecialistPicker},
  props: {
    label:{
      type: String,
      default: 'Derivar a'
    },
    eventId:{
      type: Number,
      required: true
    },
    derivation:{
      type: Object,
      required: true
    }
  },
  data(){
    return  {
      loading: false,
      selectedSpecialist: null
    }
  },
  mounted(){
    const vm = this
    if(vm.derivation && vm.derivation.specialist){
      vm.selectedSpecialist = vm.derivation.specialist
    }

  },
  methods:{
    filterSpecialists(item){
      const vm = this
      if(!vm.currentUser) return item
      return item.id !== vm.currentUser.id
    },
    onSpecialistSelect(specialist){
      const vm = this
      vm.selectedSpecialist = specialist
      vm.$nextTick(function(){
        vm.saveDerivation()
      })
    },
    async saveDerivation(){

      const vm = this

      vm.loading = true
      const response = await ApiUtils.makePatch(
          `appointments/${vm.eventId}/derivation`, null,
          {
            specialist_id: vm.selectedSpecialist.id
          }
      )
      vm.loading = false

      if(!response.ok){
        const json  = await response.json()
        return vm.toast(
            json.message || 'Ha ocurrido un error intentando cambiar el especialista'
        )
      }

    }
  }

}
</script>

<style scoped>

</style>